"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ThemeableMarkdown = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _reactMarkdown = _interopRequireDefault(require("react-markdown"));

var _Link = _interopRequireDefault(require("../button/Link"));

var _Text = _interopRequireDefault(require("./Text"));

var _styling = require("../../toolkit/styling");

var _class, _class2, _class3, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ThemeableMarkdown = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(ThemeableMarkdown, _Component);

  var _super = _createSuper(ThemeableMarkdown);

  function ThemeableMarkdown() {
    var _this;

    (0, _classCallCheck2["default"])(this, ThemeableMarkdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.renderParagraph = function (item) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(_this.styles.p)
      }, item.children);
    };

    _this.renderLink = function (_ref) {
      var href = _ref.href,
          children = _ref.children;
      var _this$props = _this.props,
          openLinksInNewTab = _this$props.openLinksInNewTab,
          onLinkClicked = _this$props.onLinkClicked,
          Link = _this$props.link;
      var openInNewTab = openLinksInNewTab == true;

      if (typeof openLinksInNewTab == "function") {
        openInNewTab = openLinksInNewTab(href) == true;
      }

      return /*#__PURE__*/_react["default"].createElement(Link, {
        href: href,
        openInNewTab: openInNewTab,
        onClick: onLinkClicked
      }, children);
    };

    _this.renderList = function (_ref2) {
      var ordered = _ref2.ordered,
          children = _ref2.children;

      /* eslint-disable local-rules/unnecessary-list-usage */
      var listStyle = _this.props.listStyle;

      if (!listStyle) {
        if (ordered) {
          return /*#__PURE__*/_react["default"].createElement("ol", null, children);
        }

        return /*#__PURE__*/_react["default"].createElement("ul", null, children);
      }

      if (ordered) {
        return /*#__PURE__*/_react["default"].createElement("ol", {
          className: (0, _styling.css)(listStyle)
        }, children);
      }

      return /*#__PURE__*/_react["default"].createElement("ul", {
        className: (0, _styling.css)(listStyle)
      }, children);
    };

    _this.renderStrong = function (_ref3) {
      var children = _ref3.children;
      return /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        weight: "semibold",
        renderAsSpan: true
      }, children);
    };

    return _this;
  }

  (0, _createClass2["default"])(ThemeableMarkdown, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          text = _this$props2.text,
          className = _this$props2.className,
          style = _this$props2.style,
          renderers = _this$props2.renderers;
      return /*#__PURE__*/_react["default"].createElement(_reactMarkdown["default"], {
        className: (0, _styling.css)(this.styles.root, className, style),
        source: text,
        renderers: _objectSpread({
          paragraph: this.renderParagraph,
          link: this.renderLink,
          list: this.renderList,
          strong: this.renderStrong
        }, renderers)
      });
    }
  }, {
    key: "styles",
    get: function get() {
      return _aphrodite.StyleSheet.create({
        root: {
          "* > div": {
            maxWidth: "100%"
          }
        },
        p: {
          maxWidth: "100%",
          overflow: "hidden"
        }
      });
    }
  }]);
  return ThemeableMarkdown;
}(_react.Component), _class3.propDoc = {
  text: {
    required: true,
    type: "string",
    description: "Text to render in markdown format"
  },
  openLinksInNewTab: {
    required: false,
    type: "boolean | (href: string) => boolean",
    defaultValue: "false",
    description: "Indicates that links in the text should be opened in a new tab. " + "If a function is passed, the function maps the link href to whether it " + "should open in a new tab."
  },
  onLinkClicked: {
    required: false,
    defaultValue: "null",
    type: "?() => void",
    description: "Optional action for clicking link"
  },
  listStyle: {
    required: false,
    defaultValue: "null",
    type: "?any",
    description: "The style of \"list\" element." + "Accept The return value of Stylesheet.create(), or raw css"
  }
}, _class3.demoProps = [{
  demoDescription: "Links",
  text: "View [tax policy](/tax/policy) to **learn more about** marketplace"
}, {
  demoDescription: "Bolded Text",
  text: "Wish Express orders must be confirmed delivered by the " + "shipping carrier within **5 working days** of the order " + "being available for fulfillment."
}, {
  demoDescription: "Italics",
  text: "Mozart\u2019s *Don Giovanni* is one of my favorite operas. " + "I also really enjoy *Beethoven\u2019s Moonlight Sonata* for piano."
}], _class3.discussion = "Learn more about markdown, check out the  " + " [markdown cheatsheet](https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet)", _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

exports.ThemeableMarkdown = ThemeableMarkdown;

var Markdown = function Markdown(props) {
  return /*#__PURE__*/_react["default"].createElement(ThemeableMarkdown, (0, _extends2["default"])({}, props, {
    link: _Link["default"]
  }));
};

Markdown.propDoc = ThemeableMarkdown.propDoc;
Markdown.demoProps = ThemeableMarkdown.demoProps;
var _default = Markdown;
exports["default"] = _default;